var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import '../../atoms/icon-button/icon-button.js';
import '@shoelace-style/shoelace/dist/components/avatar/avatar.js';
import '../../atoms/vertical-layout/vertical-layout.js';
import '../../atoms/horizontal-layout/horizontal-layout.js';
import { html, LitElement } from 'lit';
import { property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { getFullName, getInitials } from '../../helpers/nameHelpers.js';
import { emit } from '../../internal/event.js';
import styles from './ParticipantItem.styles.js';
const getFormattedParticipant = (participant) => {
    var _a;
    return ({
        fonction: participant.fonction,
        structure: (_a = participant.structure_principale) === null || _a === void 0 ? void 0 : _a.label,
    });
};
export class SgdfParticipantItem extends LitElement {
    constructor() {
        super(...arguments);
        this.skeleton = false;
        this.card = false;
        this.getFields = getFormattedParticipant;
    }
    async onClick() {
        emit(this, 'sgdf-click', { detail: this.participant });
    }
    getAvatarUrl() {
        if (this.participant.avatar_available ||
            this.participant.user_avatar_available) {
            return this.participant.avatar_available
                ? this.participant.avatar_url
                : this.participant.user_avatar_url;
        }
        return null;
    }
    render() {
        const participantFields = this.getFields(this.participant);
        return html `
            <div
                class=${classMap({ 'participant-item': true, card: this.card })}
                @click=${this.onClick}
            >
                <sgdf-horizontal-layout
                    style="align-items: center; justify-content: space-between;"
                    theme="spacing"
                >
                    <sgdf-horizontal-layout
                        style="align-items: center;"
                        theme="spacing"
                    >
                        <sl-avatar
                            initials=${ifDefined(!this.skeleton
            ? getInitials(this.participant)
            : undefined)}
                            image=${ifDefined(this.getAvatarUrl())}
                        ></sl-avatar>
                        <sgdf-vertical-layout>
                            <sgdf-horizontal-layout>
                                <span
                                    class=${classMap({
            skeleton: this.skeleton,
            'margin-right': this.info,
        })}
                                >
                                    <strong
                                        >${getFullName(this.participant)}</strong
                                    >
                                </span>
                                ${this.skeleton || !this.info
            ? null
            : html `<span class="info"
                                              >(${this.info})</span
                                          >`}
                            </sgdf-horizontal-layout>
                            ${Object.keys(participantFields).map(fieldName => html ` <span
                                        class=${classMap({
            skeleton: this.skeleton,
        })}
                                    >
                                        ${participantFields[fieldName]}
                                    </span>`)}
                        </sgdf-vertical-layout>
                    </sgdf-horizontal-layout>
                    <slot name="right"></slot>
                </sgdf-horizontal-layout>
            </div>
        `;
    }
}
SgdfParticipantItem.styles = styles;
__decorate([
    property({ type: Boolean, reflect: true })
], SgdfParticipantItem.prototype, "skeleton", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], SgdfParticipantItem.prototype, "card", void 0);
__decorate([
    property({ type: Object, reflect: true })
], SgdfParticipantItem.prototype, "participant", void 0);
__decorate([
    property()
], SgdfParticipantItem.prototype, "getFields", void 0);
__decorate([
    property({ type: String, reflect: true })
], SgdfParticipantItem.prototype, "info", void 0);
//# sourceMappingURL=ParticipantItem.js.map